import { prospectStatusLabel } from '../prospectStatus';

export function formatLocaleDateTime(value, locale = 'en-US') {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatLocaleDate(value, locale = 'en-US') {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

function formatPhoneList(record) {
  if (Array.isArray(record.phone_numbers) && record.phone_numbers.length > 0) {
    return record.phone_numbers.join(', ');
  }
  if (record.phone) return record.phone;
  return '—';
}

export function buildClientDetailExportRows(clients = [], { labels = {}, locale = 'en-US', showVendor = false } = {}) {
  return clients.map((client) => {
    const row = {
      name: client.username || '—',
      email: client.email || '—',
      phone: formatPhoneList(client),
      state: labels[client.state] || client.state || '—',
      referrals: String(client.referrals_count ?? 0),
      createdAt: formatLocaleDateTime(client.created_at, locale),
      stateUpdatedAt: formatLocaleDateTime(client.state_updated_at, locale),
    };
    if (showVendor) {
      row.representatives = Array.isArray(client.vendor_usernames) && client.vendor_usernames.length > 0
        ? client.vendor_usernames.join(', ')
        : '—';
    }
    return row;
  });
}

function resolveSaleTypeLabel(saleType, t) {
  if (!saleType) return '—';
  const key = String(saleType).trim().toUpperCase();
  return t?.vendor?.prospects?.saleTypes?.[key] || saleType;
}

export function buildProspectDetailExportRows(
  prospects = [],
  { t, prospectStatuses = [], locale = 'en-US', showVendor = false } = {}
) {
  return prospects.map((prospect) => {
    const row = {
      name: prospect.name || '—',
      email: prospect.email || '—',
      phone: formatPhoneList(prospect),
      address: prospect.address || '—',
      status: prospectStatusLabel(prospect.status, t, prospectStatuses) || prospect.status || '—',
      saleType: resolveSaleTypeLabel(prospect.sale_type, t),
      createdAt: formatLocaleDateTime(prospect.created_at, locale),
      updatedAt: formatLocaleDateTime(prospect.updated_at, locale),
    };
    if (showVendor) {
      row.representative = prospect.vendor_username || '—';
    }
    return row;
  });
}

export function getClientDetailColumns(labels = {}, showVendor = false) {
  const columns = [
    { key: 'name', label: labels.clientName || 'Client' },
    { key: 'email', label: labels.email || 'Email' },
    { key: 'phone', label: labels.phone || 'Phone' },
    { key: 'state', label: labels.state || 'State' },
    { key: 'referrals', label: labels.referrals || 'Referrals' },
    { key: 'createdAt', label: labels.createdAt || 'Created' },
    { key: 'stateUpdatedAt', label: labels.stateUpdatedAt || 'State updated' },
  ];
  if (showVendor) {
    columns.push({ key: 'representatives', label: labels.representatives || 'Representatives' });
  }
  return columns;
}

export function getProspectDetailColumns(labels = {}, showVendor = false) {
  const columns = [
    { key: 'name', label: labels.prospectName || 'Prospect' },
    { key: 'email', label: labels.email || 'Email' },
    { key: 'phone', label: labels.phone || 'Phone' },
    { key: 'address', label: labels.address || 'Address' },
    { key: 'status', label: labels.status || 'Status' },
    { key: 'saleType', label: labels.saleType || 'Sale type' },
    { key: 'createdAt', label: labels.createdAt || 'Created' },
    { key: 'updatedAt', label: labels.updatedAt || 'Updated' },
  ];
  if (showVendor) {
    columns.push({ key: 'representative', label: labels.representative || 'Representative' });
  }
  return columns;
}
